import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

function PrivacyPolicy() {
  return (
    <Container className="mt-5 pt-5 pb-5" style={{ maxWidth: "900px", color: "#ffffff" }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-center mb-4">Privacy Policy</h1>
        <p className="text-center text-muted">Effective date: May 7, 2025</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        <section className="mb-5">
          <h4>1. Introduction</h4>
          <p>
            This website is an informational platform designed for consultation and general browsing. We do not offer user registration, login systems, or the ability to create personal accounts. Therefore, we do not intentionally collect or store personal information such as names, email addresses, or passwords.
          </p>
        </section>

        <section className="mb-5">
          <h4>2. Automatically Collected Information</h4>
          <p>
            Like most websites, we may collect certain technical data automatically when you visit the site. This includes:
          </p>
          <ul>
            <li>Your IP address</li>
            <li>Browser type and version</li>
            <li>Pages visited and time spent</li>
            <li>Referring URLs</li>
            <li>Device type (mobile/desktop)</li>
          </ul>
          <p>
            This data is used only for technical analytics and site performance optimization. It is not used to identify individuals.
          </p>
        </section>

        <section className="mb-5">
          <h4>3. Cookies</h4>
          <p>
            We may use cookies to enhance your browsing experience. Cookies are small text files stored in your browser that help remember user preferences or improve performance.
          </p>
          <p>
            You can manage or disable cookies through your browser settings. However, disabling cookies may affect the site's performance or layout.
          </p>
        </section>

        <section className="mb-5">
          <h4>4. Third-Party Services</h4>
          <p>
            We may use third-party services such as Google Analytics and Google AdSense. These services may use cookies and tracking technologies to collect anonymous information about your usage of the site, including:
          </p>
          <ul>
            <li>Which pages are viewed</li>
            <li>Time spent on each page</li>
            <li>Non-personal demographic data</li>
          </ul>
          <p>
            These third parties may use their own privacy policies, which we do not control. For more information, we recommend reading Google’s privacy policies.
          </p>
        </section>

        <section className="mb-5">
          <h4>5. Data Sharing and Selling</h4>
          <p>
            We do not sell, rent, or share your personal data with third parties. Since we do not collect any personal data intentionally, there is no identifiable information to distribute or exploit.
          </p>
        </section>

        <section className="mb-5">
          <h4>6. User Rights (EU / GDPR)</h4>
          <p>
            Even though we do not collect personal data, we respect your right to privacy. Under the General Data Protection Regulation (GDPR), you have the right to:
          </p>
          <ul>
            <li>Access data we may hold about you</li>
            <li>Request deletion or correction</li>
            <li>Object to data processing</li>
          </ul>
          <p>
            If you believe any data has been collected that affects your privacy, please contact us.
          </p>
        </section>

        <section className="mb-5">
          <h4>7. Security</h4>
          <p>
            While we do not store sensitive data, we implement standard security measures (such as HTTPS encryption) to ensure that browsing is safe and protected from unauthorized access or tampering.
          </p>
        </section>

        <section className="mb-5">
          <h4>8. Changes to this Policy</h4>
          <p>
            This Privacy Policy may be updated occasionally to reflect changes in technology, regulations, or site functionality. Any updates will be posted on this page with the date of revision.
          </p>
        </section>

        <section>
          <h4>9. Contact</h4>
          <p>
            If you have any concerns or questions about this Privacy Policy, please feel free to contact us at:{" "}
            <a href="mailto:raedmadouri@gmail.com" style={{ color: "#a0e7f5" }}>
              raedmadouri@gmail.com
            </a>
          </p>
        </section>
      </motion.div>
    </Container>
  );
}

export default PrivacyPolicy;
